module.exports = __webpack_public_path__ + "img/hp-h2.5ca8cfce.svg";